import kotlinx.browser.window

object NetworkMonitor {
    var isOffline: Boolean = !window.navigator.onLine
        private set
    private val listeners = mutableListOf<(Boolean) -> Unit>()

    init {
        window.addEventListener("online", {
            isOffline = false
            notifyListeners()
        })
        window.addEventListener("offline", {
            isOffline = true
            notifyListeners()
        })
    }

    fun addListener(listener: (Boolean) -> Unit): () -> Unit {
        listeners.add(listener)
        return { listeners.remove(listener) }
    }

    private fun notifyListeners() {
        listeners.toList().forEach { it(isOffline) }
    }
}
